import { createSlice } from '@reduxjs/toolkit';
import {
  createAdminOrder,
  getAdminEditOrder,
  getAdminOrders,
  updateAdminOrder,
} from './adminOrders.actions';

const initialState = {
  orders: [],
  ordersMeta: {},
  isLoadingOrders: false,

  selectedOrder: {},
  isLoadingOrder: false,

  errors: {},
};

const adminOrdersSlice = createSlice({
  name: 'adminOrders',
  initialState,
  reducers: {
    setAdminOrdersMeta: (state, action) => {
      state.ordersMeta = action.payload;
    },
    setSelectedAdminOrder: (state, action) => {
      state.selectedOrder = action.payload;
    },
    setAdminOrderErrors: (state, action) => {
      state.errors = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAdminOrders.pending, (state) => {
      state.isLoadingOrders = true;
    });
    builder.addCase(getAdminOrders.fulfilled, (state, action) => {
      state.orders = action.payload;
      state.isLoadingOrders = false;
    });
    builder.addCase(getAdminOrders.rejected, (state) => {
      state.isLoadingOrders = false;
    });

    builder.addCase(createAdminOrder.pending, (state) => {
      state.isLoadingOrder = true;
    });
    builder.addCase(createAdminOrder.fulfilled, (state) => {
      state.isLoadingOrder = false;
    });
    builder.addCase(createAdminOrder.rejected, (state) => {
      state.isLoadingOrder = false;
    });

    builder.addCase(getAdminEditOrder.pending, (state) => {
      state.isLoadingOrder = true;
    });
    builder.addCase(getAdminEditOrder.fulfilled, (state, action) => {
      state.selectedOrder = action.payload;
      state.isLoadingOrder = false;
    });
    builder.addCase(getAdminEditOrder.rejected, (state) => {
      state.isLoadingOrder = false;
    });

    builder.addCase(updateAdminOrder.pending, (state) => {
      state.isLoadingOrder = true;
    });
    builder.addCase(updateAdminOrder.fulfilled, (state) => {
      state.isLoadingOrder = false;
    });
    builder.addCase(updateAdminOrder.rejected, (state) => {
      state.isLoadingOrder = false;
    });
  },
});

export const { setAdminOrdersMeta, setSelectedAdminOrder, setAdminOrderErrors } =
  adminOrdersSlice.actions;

export default adminOrdersSlice.reducer;
